import {Directive } from "@angular/core"

@Directive({
    selector: "[rxTabContent]"
})
export class RxTabContentDirective {
}


// WEBPACK FOOTER //
// ./node_modules/@rx/view/tab/rx_tab_content_control_directive.ts